import styled from "styled-components";

const AboutWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 5px;
  align-items: center;
  @media (max-width: 990px) {
    padding: 80px 45px 30px 45px;
  }
  @media (max-width: 575px) {
    padding: 60px 25px 0 25px;
  }
  .card-container {
    background: #00d2ff;
    background: -webkit-linear-gradient(
      to right,
      #3a7bd5,
      #00d2ff
    );
    background: linear-gradient(
      to right,
      #3a7bd5,
      #00d2ff
    );

    border-radius: 10px;
    box-shadow: 0px 10px 20px -10px rgba(0, 0, 0, 0.75);
    color: white;
    padding: 30px;
    position: relative;
    width: 350px;
    max-width: 100%;
    text-align: center;
    & .bg-text {
      display: flex;
      margin-top: 20px;
      flex-direction: column;
      justify-content: center;
      box-shadow: 0px 10px 20px -10px rgba(0, 0, 0, 0.75);

      border-bottom: 20px;
      border-top: none !important;
      border-bottom-style: none !important;
    }
    & .pro {
      color: white;
      background-color: #febb0b;
      border-radius: 3px;
      font-size: 14px;
      font-weight: bold;
      padding: 3px 7px;
      position: absolute;
      top: 30px;
      left: 30px;
    }
    & .round {
      border: 1px solid linear-gradient(to right, #ff9472, #f2709c);
      border-radius: 50%;
      width: 65%;
      padding: 4px;
    }
  }

  & .skills {
    /* background-color: #1f1a36; */
    color: white;
    font-size: 20px;
    text-align: left;
    padding: 15px;
    margin-top: 30px;
    & ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      & li {
        font-weight: bold;
        border: 2px solid white;
        border-radius: 2px;
        display: inline-block;
        font-size: 12px;
        margin: 0 7px 7px 0;
        padding: 7px;
      }
    }
  }
`;

export default AboutWrapper;
